/**
 * @ngdoc directive
 * @name d3 Pie Chart
 *
 * @description
   Shows pie chart from d3.js library
 *
 * @scope
 * @param {String} id - id
 * @param {Array} data - chart data
 * @param {Number} width - width
 * @param {Number} height - height
 * @param {Boolean} showLabels - show labels
 * @param {Number} offsetX - offsetX
 * @param {Number} offsetY - offsetY
 *
 * @example
    <d3pie-chart id="chart-1"
      data='[{"label":"Food & Beverage,67%","value":12663.6,"color":"#1f77b4"},{"label":"Liquor,12%","value":2337.07,"color":"#aec7e8"},{"label":"Beer,4%","value":659.69,"color":"#ff7f0e"},{"label":"Wine,2%","value":401.44,"color":"#ffbb78"},{"label":"Other,15%","value":2726.9,"color":"#2ca02c"}]'
      width="380"
      height="280"
      offsetX="170"
      offsetY="210">
    </d3pie-chart>
 */

D3pieChart.$inject = ["PATH", "$timeout"];
app.directive('d3pieChart', D3pieChart);

function D3pieChart(PATH, $timeout) {
  return {
    restrict: 'E',
    scope: {
      id: '@',
      data: '=',
      width: '=',
      height: '=',
      showLabels: '=',
      offsetX: '=',
      offsetY: '='
    },
    link: function (scope, element) {

      scope.update = function (data) {
        if (scope.chart.update) {
          scope.chart.update(data);
        }
      };

      scope.onDataChange = function (data) {
        if (data && !_.isEmpty(data)) {
          if (scope.drawn) {
            return scope.update(data);
          } else {
            return scope.draw(data);
          }
        }
      };

      scope.draw = function (data) {
        element[0].id = scope.id;
        scope.chart = new d3pie(scope.id, {
          size: {
            canvasHeight: scope.height,
            canvasWidth: scope.width,
            pieInnerRadius: 0,
            pieOuterRadius: '60%'
          },
          data: {
            smallSegmentGrouping: {
              enabled: false,
              value: 0
            },
            sortOrder: 'label-desc',
            content: data
          },
          effects: {
            load: {
              effect: 'none', // none / default
              speed: 1000
            },
            pullOutSegmentOnClick: {
              effect: 'none',
              speed: 400,
              size: 7
            },
            highlightLuminosity: 0.1
          },
          labels: {
            outer: {
              format: 'label',
              pieDistance: 5
            },
            inner: {
              format: 'none',
              hideWhenLessThanPercentage: 0
            },
            mainLabel: {
              color: '#333333',
              font: 'arial',
              fontSize: 10
            },
            percentage: {
              color: '#333333',
              font: 'arial',
              fontSize: 10,
              decimalPlaces: 0
            },
            value: {
              color: '#cccc44',
              font: 'arial',
              fontSize: 10
            },
            lines: {
              enabled: true,
              style: 'curved',
              color: 'segment'
            }
          },
          misc: {
            gradient: {
              enabled: false,
              percentage: 100
            },
            pieCenterOffset: {
              x: scope.offsetX || 0,
              y: scope.offsetY || 0
            }
          }
        });

        scope.drawn = true;
      };

      scope.$watch('data', scope.onDataChange, true);
    }
  };
}



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/d3pieChart/d3pieChart.js